<template>
  <div>
      <h2>Child 3</h2>
      {{localValue}}
      <button @click="++localValue"></button>
  </div>
</template>

<script>
export default {
    computed: {
        localValue:{
            get(){
                return this.value 
            },
            set(value){
                this.$emit('input',value)
            }
        }
    },
    props:{
        value:Number
    }
    
}
</script>

<style>

</style>